(function($){
	$(document).ready(function() {		
    	addToCartManagement($);

		// ON SCROLL EVENTS //

		var hasScrolled = false;
		var header = $(".main-header");
		var headerHeigh = $(".main-header").outerHeight();
		var scrollpos = 0;
		$(function() {
			$(window).scroll(function() {
				var scroll = $(window).scrollTop();
				scrollpos = scroll;
				if (scroll >= headerHeigh) {
					header.addClass("scrolled");
					hasScrolled = true;
				} else {
					header.removeClass("scrolled");
					hasScrolled = false;
				}
			});
		});

		qty_toggle();

		var windowWidth = $(window).width();
		if (windowWidth < 768 ) {
			var headerCart = $('.header_cart').detach();
			$('#mCart').append(headerCart);
		} else {
			$('.menu').append(headerCart);
		}

		$( window ).resize(function() {
			var windowWidth = $(window).width();
			var headerCart = $('.header_cart').detach();
			if (windowWidth < 768 ) {
				$('#mCart').append(headerCart);
			} else {
				$('.menu').append(headerCart);
			}
		});

		// ON CLICK EVENTS //

		$(".siteMenu li.dropdown").each(function() {
			$(this).on("click", function(e){
				// If this is already opened - go to link.
				if ($(this).hasClass("dropdown_open")){

					return;
				}
				else{
					e.preventDefault();
				}

				// Find all already opened.
				var openDropDowns = $(".dropdown_open");
				console.log(openDropDowns);
				openDropDowns.each(function(){
					$(this).removeClass("dropdown_open");
					$(this).find('.sub-menu').slideUp();
				});

				// Open this.
				$(this).addClass("dropdown_open");
				$(this).find('.sub-menu').slideDown();
			});
		});

		$('.mMenu').on('click', function(){
			$('.main-header').toggleClass('navOpen');
			$('.siteMenu').slideToggle();
		});

		$('.top-nav-mMenu').on('click', function(){
			$('.main-header').toggleClass('topnavOpen');
			$('.top-nav').slideToggle();
		});

		$('.submenuToggle').on('click', function(){
			$('.submenuToggle').toggleClass('submenuOpen');
			$('#sidemenu').slideToggle();
		});

	});



	function qty_toggle() {
		$('.toggle_qty').on('click',function(e){
			e.preventDefault();

			var parent_elem = $(this).parent();
			var input  = $($(parent_elem).find('.qty')[0]);
			if ($(this).hasClass('add_qty')){
				var value = parseInt(input.val());
				value++;
				input.val(value);
			} else {
				var value = parseInt(input.val());
				value--;
				value = Math.max(0, value);
				input.val(value);
			}
		});
	}
	
	
	$('a[href^="#"]').on('click',function (e) {
        e.preventDefault();

        var target = this.hash;
        var $target = $(target);

        $('html, body').stop().animate({
            'scrollTop': $target.offset().top
        }, 900, 'swing', function () {
            window.location.hash = target;
        });
    });


})(jQuery);

function addToCartManagement($){
  // Hook up click.
  $(".single_add_to_cart_button").on("click", function(){
    $(this).addClass("active");
  });

  $(document).ajaxComplete(function(event, request, settings){


    if ($(event.target).hasClass("single_add_to_cart_button")){
      $(event.target).removeClass("active");
    }
  });
}
